import { ApiError } from "@nabble/sdk";
import { errorMessage } from "../../../../errors";

/** Why a second factor couldn't be removed; the last one always stays. */
export function factorErrorMessage(err: unknown): string {
  return err instanceof ApiError && err.code === "last_factor" ? "You must keep at least one second factor." : errorMessage(err, "Please try again.");
}
